import dayjs from 'dayjs';
import Dexie, { Table } from 'dexie';

export interface GIS {
  DBName: string;
  GISDATA: any;
  MapSet: string;
  Status: string;
  Kilometrierung: boolean;
}

/*StorageDexieDB
 * Einfach eine DB zum Speichern von größeren Daten, z.B. GISMAP-Features
 */
export class StorageDB extends Dexie {
  gis!: Table<GIS, string>;
  nowFormat: string = 'YYYY-MM-DDTHH:mm:ss';
  constructor() {
    super(`Storage`);
    this.version(1).stores({
      gis: '&DBName, GISDATA',
    });
  }

  //Key = Name der DB + MapSet
  public async getGIS(key: string): Promise<any> {
    return (await dbS.gis.get(key))?.GISDATA;
  }
  public async getGISDate(key: string): Promise<string> {
    return (await dbS.gis.get(key))?.Status;
  }
  public async getGISKilometrierung(key: string): Promise<boolean> {
    return (await dbS.gis.get(key))?.Kilometrierung;
  }

  public async updateGISDate(key: string): Promise<number> {
    return await dbS.gis.update(key, { Status: dayjs().format(this.nowFormat) });
  }
  public async saveIntoGIS(gisData: string, dbname: string, mapSet: number, kilometrierung: boolean) {
    await dbS.gis.put({
      DBName: dbname + mapSet,
      GISDATA: gisData,
      MapSet: mapSet.toString(),
      Status: dayjs().format(this.nowFormat),
      Kilometrierung: kilometrierung,
    });
  }
  public async clearGis() {
    await dbS.gis.clear();
  }
}

export const dbS = new StorageDB();
